import React, { useState } from 'react';
import styles from './Expandables.module.scss';
import arrowRight from '../../../../src/assets/images/Right-arrow.svg';
import CloseIcon from '@material-ui/icons/Close';
import externalLink from '../../../../src/assets/images/external-link.svg';

const Expandables = ({ topic, icon, index, index1 }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <div className={styles.expandable}>
        <div
          className={`${styles.title} ${isOpen ? styles.expanded : styles.collapsed}`}
          tabIndex="0"
          href="javascript:void(0)"
          onClick={() => setOpen(!isOpen)}
          onKeyPress={event => {
            if (event.key === 'Enter') {
              setOpen(!isOpen);
            }
          }}
          aria-expanded={isOpen}
          aria-controls={`id${index}${index1}`}
        >
          {!isOpen ? (
            <span className={`${styles.chevron} ${styles.bottom}`}></span>
          ) : (
            <span className={`${styles.chevron} ${styles.top}`}></span>
          )}
          {topic.title}
          <img src={arrowRight} alt={`drill down arrow`} className={`${styles.drillDownArrow}`} />
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: topic.text }}
          className={`${isOpen ? styles.open : styles.close} ${styles.expandedSection}`}
          id={`id${index}${index1}`}
        />
        <div className={` ${isOpen ? styles.open : null}`}>
          <div className={`${styles.mobileSidePanel}`}>
            <div className={styles.mobiletitle}>
              <a
                tabIndex="0"
                href="javascript:void(0)"
                aria-label="close"
                onClick={() => setOpen(false)}
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    setOpen(false);
                  }
                }}
              >
                <CloseIcon className={styles.menuIcon} />
              </a>
            </div>
            <div className={styles.mobileContent}>
              <img src={`../images/${icon}`} alt="icon"></img>
              <h3> {topic.title}</h3>
              <div dangerouslySetInnerHTML={{ __html: topic.text }} />
              {!icon.includes('Contact_us') ? (
                <div>
                  <h4>Can’t find what you’re looking for? </h4>
                  <div className={styles.contactUs}>
                    <a href="/contact-us" target="_blank">
                      Contact us
                      <img src={externalLink} alt="external link" className={styles.externalLink} />
                    </a>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expandables;
